
















import { Component, Vue } from 'vue-property-decorator';
import { BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue';

@Component({
    name: 'Jumbotron',
    components: {
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'b-dropdown-divider': BDropdownDivider,
    },
})
export default class Dropup extends Vue {
    public show: boolean = false;

    public go(route: string) {
        return this.$router.replace(route);
    }
}
